import { render, staticRenderFns } from "./SideBarPrintingCutting.vue?vue&type=template&id=4ce0305c"
import script from "./SideBarPrintingCutting.vue?vue&type=script&lang=js"
export * from "./SideBarPrintingCutting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports